import React from 'react';
import { coreFunctions } from '../mockData';
import { GraduationCap, Wrench, Briefcase, MessageSquare, Rocket, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';

const CoreFunctions = () => {
  const iconMap = {
    'GraduationCap': GraduationCap,
    'Wrench': Wrench,
    'Briefcase': Briefcase,
    'MessageSquare': MessageSquare,
    'Rocket': Rocket
  };

  const handleExploreClick = (func) => {
    // All buttons scroll to join form
    const ctaSection = document.getElementById('cta-join');
    ctaSection?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="functions" className="core-functions-section">
      <div className="core-functions-container">
        {/* Section Header */}
        <div className="section-header">
          <h2 className="section-title">What We Offer</h2>
          <p className="section-description">
            Five powerful pillars designed to transform you into an AI-native expert
          </p>
        </div>

        {/* Functions Grid */}
        <div className="functions-grid">
          {coreFunctions.map((func, index) => {
            const Icon = iconMap[func.icon];
            const isEven = index % 2 === 0;
            
            return (
              <div 
                key={func.id} 
                id={func.title.toLowerCase()}
                className={`function-card ${isEven ? 'card-left' : 'card-right'}`}
              >
                <div className="function-content">
                  <div className="function-header">
                    <div className="function-icon">
                      <Icon size={32} />
                    </div>
                    <h3 className="function-title">{func.title}</h3>
                  </div>
                  
                  <p className="function-description">{func.description}</p>
                  
                  <ul className="function-features">
                    {func.features.map((feature, idx) => (
                      <li key={idx} className="feature-item">
                        <span className="feature-bullet"></span>
                        {feature}
                      </li>
                    ))}
                  </ul>

                  <Button 
                    variant="ghost" 
                    className="function-button"
                    onClick={() => handleExploreClick(func)}
                  >
                    Explore {func.title} {func.comingSoon && '(Coming Soon)'}
                    <ArrowRight size={16} />
                  </Button>
                </div>

                <div className="function-image-wrapper">
                  <img 
                    src={func.image} 
                    alt={func.title}
                    className="function-image"
                  />
                  <div className="image-overlay"></div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default CoreFunctions;
